<div [formGroup]="form" class="modalForm">
  <div class="flex flex-column gap-2 mb-3" style="grid-column: 1 / 3">
    <label for="message" class="font-semibold w-full">{{ "system_alerts.form.message" | translate }}*</label>
    <input pInputText id="message" formControlName="message" autocomplete="off" />
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <label for="startTime" class="font-semibold w-full">{{ "system_alerts.form.start_time" | translate }}*</label>
    <p-datepicker
      [iconDisplay]="'input'"
      [showIcon]="true"
      [showWeek]="true"
      [firstDayOfWeek]="1"
      id="startTime"
      formControlName="startTime"
      dateFormat="dd.mm.yy"
      inputStyleClass="w-full"
      appendTo="body"
    />
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <label for="endTime" class="font-semibold w-full">{{ "system_alerts.form.end_time" | translate }}*</label>
    <p-datepicker
      [iconDisplay]="'input'"
      [showIcon]="true"
      [showWeek]="true"
      [firstDayOfWeek]="1"
      id="endTime"
      formControlName="endTime"
      dateFormat="dd.mm.yy"
      inputStyleClass="w-full"
      appendTo="body"
    />
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <label for="showInApp" class="font-semibold w-full">{{ "system_alerts.form.show_in_app" | translate }}*</label>
    <p-checkbox inputId="showInApp" formControlName="showInApp" [binary]="true" />
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <label for="showInWeb" class="font-semibold w-full">{{ "system_alerts.form.show_in_web" | translate }}*</label>
    <p-checkbox inputId="showInWeb" formControlName="showInWeb" [binary]="true" />
  </div>
</div>

<div class="flex justify-content-end gap-2 dialogBtnGroup mb-3">
  <app-button buttonText="Speichern" [disabled]="form.invalid" (click)="saveSystemAlert()"></app-button>
</div>
